<template>
  <b-row class="justify-content-center align-items-center h-100 m-0">
    <b-col cols="auto" sm="6" md="4" lg="4" xl="3">
      <div>
        <img src="@/assets/4life-logo.svg" class="mb-4" height="60" />
        <h5 class="display-4 mt-1 mb-2 font-weight-bold">Reset your password</h5>
        <p class="text-black-50">This link can no longer be used to complete your request.</p>
      </div>

      <b-button class="w-100 mt-4" variant="outline-primary" @click="goToSignIn()"
        >Go to sign in page</b-button
      >
    </b-col>
  </b-row>
</template>

<script>
export default {
  methods: {
    goToSignIn() {
      this.$router.push({ name: 'SignIn' });
    }
  }
};
</script>
